module.exports = __webpack_public_path__ + "static/media/dt-page4.437ed5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rbcx/dt-page4.png
// module id = 46
// module chunks = 0